import Request from "@/shared/utils/_request";
class Hunter {
  constructor() { }
  getHunterList(payload) {
    return Request.post("/hunter/search", payload);
  }
  getHunterInfo(payload) {
    return Request.post("/hunter/detail", payload);
  }
  getContractList(payload) {
    //合同列表
    return Request.post("/hunter/contract/get-list", payload);
  }
  acceptContract(payload) {
    //合同审核通过
    return Request.post("/hunter/contract/accept", payload);
  }
  rejectContract(payload) {
    //合同审核不通过
    return Request.post("/hunter/contract/reject", payload);
  }
  addSign(payload) {
    //标记开发人
    return Request.post("/hunter/registerHunter", payload);
  }
  /**
   * 添加备注 跟进
   * @param {{user_id,body}} payload
   */
  addRemark(payload) {
    return Request.post("/hunter/hunter-remark/create", payload);
  }
  /**
   * 转为有效猎头
   * @param {{user_id}} payload
   */
  changeValidHunter(payload) {
    return Request.post("/hunter/hunter-remark/changeValidHunter", payload);
  }
  /**
   * 获取备注
   * @param {{user_id}} payload
   */
  getAllRemark(payload) {
    return Request.post("/hunter/hunter-remark/get-all", payload);
  }
  /**
   * 数据看板
   * @param {{created_start, created_end, name,tel}} payload
   */
  getDashboardData(payload) {
    return Request.post("/hunter/getPmUserData", payload);
  }
  getActivationData(payload) {
    return Request.post("/hunter/getPmActiveUserData", payload);
  }

  /**
   * 做单数据
   * @param {*} payload
   */
  getPostData(payload) {
    return Request.post("/hunter/post/search", payload);
  }

  /**
   * 开发者关系转移
   * @param {{user_id,ie_user_id}} payload
   */
  transformPm(payload) {
    return Request.post("/hunter/transformPm", payload);
  }

  /**
   * 人岗匹配列表
   * @param {{type, order }} payload
   */
  getRecommendList(payload) {
    return Request.post("/hunter/recommend-result/list", payload);
  }

  /**
   * 人岗匹配拒绝
   * @param {{type, order }} payload
   */
  rejectRecommond(payload) {
    return Request.post("/hunter/recommend-result/reject", payload);
  }

  /**
   * 人岗匹配标记
   * @param {{type, order }} payload
   */
  getRecommendBlackList(payload) {
    return Request.post("/hunter/recommendBlackList/get-list", payload);
  }
   /**
   * 人岗匹配创建标记
   * @param {{type, order }} payload
   */
  createRecommendBlack(payload) {
    return Request.post("/hunter/recommendBlackList/create", payload);
  }
   /**
   * 人岗匹配删除标记
   * @param {{type, order }} payload
   */
  deleteRecommendBlack(payload) {
    return Request.post("/hunter/recommendBlackList/delete", payload);
  }
  /**
   * 猎头求助订单列表
   */
  ask_help(payload) {
    return Request.post("/post/ask_help/getList", payload);
  }
  /**
   * 猎头求助受理
   */
  ask_accept(payload) {
    return Request.post("/post/ask_help/accept", payload);
  }
  /**
   * 猎头求助拒绝
   */
  ask_recject(payload) {
    return Request.post("/post/ask_help/reject", payload);
  }
  /**
   * 猎头求助解决
   */
  ask_solve(payload) {
    return Request.post("/post/ask_help/solve", payload);
  }
  /**
   * 猎头求助列表
   */
  ask_acceptList(payload) {
    return Request.post("/post/ask_help/acceptList", payload);
  }
  /**
   * 获取所有的收费与开票记录
   */
  communicate_income(payload) {
    return Request.post("/post/post-income/get-all", payload);
  }
  /**
   * 新增收费金额
   */
  communicate_setIncomeAmount(payload) {
    return Request.post("/post/setIncomeAmount", payload);
  }
  communicate_create(payload) {
    return Request.post("/post/post-income/create", payload);
  }





  enterprisecompany(payload) {
    return Request.post("/hunter/hunter-company/getCompanyPostStatisticsList", payload);
  }
  enterprisegetNewest(payload) {
    return Request.post("/hunter/contract/getNewest", payload);
  }
  enterpriseStatuses(payload) {
    return Request.post("/post/getHunterCompanyStatuses", payload);
  }
  enterpriseHunter(payload) {
    return Request.post("/hunter/hunter-company/getHunterPostStatisticsList", payload);
  }

  kpigetIeData(payload) {
    return Request.post("/kip/getIeData", payload);
  }
  kpigetBdData(payload) {
    return Request.post("/kip/getBdData", payload);
  }
  kpigetLandDevData(payload) {
    return Request.post("/kip/getLandDevData", payload);
  }
  kpigetLandPostData(payload) {
    return Request.post("/kip/getLandPostData", payload);
  }
}

export const hunter = new Hunter();
